import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import entries from 'lodash/entries';

import { sendEmail } from '@api/mail';
import Button from 'components/atoms/Button';
import Rocket from '@public/icons/rocket.svg';
import { THANK_YOU } from '@shared/constants/navigate';
import { FormBase, FormJoin } from '@shared/interfaces/form';

type BtnProps = {
  formData: FormBase | FormJoin;
  notRequiredKeys: Array<keyof FormJoin> | Array<keyof FormBase>;
};

function GetStartedBtn({ formData, notRequiredKeys }: BtnProps) {
  const [submitted, setSubmitted] = useState(false);
  const [canSubmit, setCanSubmit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { push } = useRouter();

  useEffect(() => {
    let requiredKeys = entries(formData);

    notRequiredKeys.forEach((targetKey) => {
      requiredKeys = requiredKeys.filter(([key]) => key !== targetKey);
    });

    const hasNotFilled = requiredKeys.some(([, value]) => !value);

    setCanSubmit(!hasNotFilled);
  }, [formData]);

  const onSendEmail = async () => {
    setLoading(true);
    setCanSubmit(false);

    try {
      const res = await sendEmail(formData);
      setSubmitted(true);

      if (!res) setError(true);
      else {
        setTimeout(async () => {
          await push(THANK_YOU);
        }, 1000);
      }
    } finally {
      setCanSubmit(true);
      setLoading(false);

      setTimeout(() => {
        setSubmitted(false);
        setError(false);
      }, 1000);
    }
  };

  const icon = loading
    ? 'icons/pulse-rings.svg'
    : submitted
      ? error
        ? 'icons/cross.svg'
        : 'icons/check_mark.svg'
      : Rocket;

  const bgColor = !canSubmit
    ? 'buttonDisabled'
    : submitted
      ? error
        ? 'scarlet'
        : 'forestGreen'
      : 'textPrimary';

  const title = submitted
    ? error
      ? 'Send Request Failed'
      : 'Request Sent!'
    : 'Get Started';

  const disabled = !canSubmit || loading;

  return (
    <Button
      Icon={icon}
      height="48px"
      width="243px"
      color="white"
      title={title}
      bgColor={bgColor}
      disabled={disabled}
      onClick={onSendEmail}
    />
  );
}

export default GetStartedBtn;
